"use client";

import React, {useEffect} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";

export interface ErrDialogProps extends SDialogProps {
    msg: string;
}

export const ErrDialogFC: React.FC<ErrDialogProps> = (props) => {
    const {fcKey, onClose, msg, title} = props;

    const {closeDialog} = useDialogMethods(fcKey);

    useEffect(() => {
        return () => {
        };
    }, []);

    const onCloseDialog = (isRefresh:boolean) => {
        onClose?.(isRefresh);
        closeDialog();
    }

    const onClickRefresh = () => {
        // showForceLoading();
        onCloseDialog(true);
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Center"
            onClose={onClose}
            title={title}
            buttons={[
                {
                    label: "Refresh",
                    onClick: () => {
                        onClickRefresh();
                    },
                    style: "greenBtn",
                },
            ]}
        >
            <p>{msg}</p>
        </SDialogFC>
    );
};

export interface errProps{
    isRefresh:boolean;
}

export async function showErrDialog(code:any, message:string) {
    return new Promise<errProps>((resolve, reject) => {
        SDialogManagerFC.openDialog(ErrDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(ErrDialogFC),
            title: `Server error code: ${code}`,
            msg: `${message}`,
            onClose: (isRefresh:boolean) => {
                resolve({isRefresh:isRefresh}) // 或者自己定义一个原因
            }
        })
    });
}

